import { ethers } from 'ethers'

export const MULTICALL3_ADDRESS = '0xcA11bde05977b3631167028862bE2a173976CA11'

const MULTICALL3_ABI = [
    'function aggregate3((address target,bool allowFailure,bytes callData)[] calls) payable returns ((bool success,bytes returnData)[] returnData)',
]

export function decodeMulticallResults(calls, results) {
    return results.map((result, index) => {
        const call = calls[index]
        if (!result.success) {
            if (Object.prototype.hasOwnProperty.call(call, 'fallback')) return call.fallback
            throw new Error(`Multicall failed: ${call.functionName}`)
        }
        const decoded = call.iface.decodeFunctionResult(call.functionName, result.returnData)
        return decoded.length === 1 ? decoded[0] : decoded
    })
}

export async function marketplaceMulticall(provider, calls) {
    const contract = new ethers.Contract(MULTICALL3_ADDRESS, MULTICALL3_ABI, provider)
    const payload = calls.map((call) => ({
        target: call.target,
        allowFailure: Object.prototype.hasOwnProperty.call(call, 'fallback'),
        callData: call.iface.encodeFunctionData(call.functionName, call.args || []),
    }))

    try {
        const results = await contract.callStatic.aggregate3(payload)
        return decodeMulticallResults(calls, results)
    } catch (multicallError) {
        return Promise.all(calls.map(async (call) => {
            const target = new ethers.Contract(call.target, call.iface.fragments, provider)
            try {
                return await target[call.functionName](...(call.args || []))
            } catch (error) {
                if (Object.prototype.hasOwnProperty.call(call, 'fallback')) return call.fallback
                throw error
            }
        }))
    }
}
